// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"1cba4cd8","373":"a21bd764","677":"13b0e370"}[chunkId] + ".chunk.css";
};